function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import __ from 'ramda/src/__';
import clone from 'ramda/src/clone';
import pathOr from 'ramda/src/pathOr';
import moment from 'moment';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { CUSTOMER_URL } from '../../customer/customer.config';
import { DASHBOARD_ROUTE } from '../../../reducers/constants/dashboard.constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { updateOverrideFlag } from '../../../reducers/actions/customer.addresses.actions';
import { formHasErrors } from 'invision-core/src/components/helpers/form.helper';
import { ROCWarningTranslatedMessageSelector } from 'invision-core/src/components/warnings/warnings.selectors';
import { MetadataCodeLoadedSelector, MetadataCodeTypeIntegerSelector, MetadataCodeTypeSelector, MetadataOptionsForCodeValuesWithoutPlaceholderSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { subscriberOrderTypeEnum } from 'invision-core/src/utilities/subscriber.order.type.enum';
import { LastRouteSelector, PageSizePreferenceSelector } from 'invision-core/src/components/session/session.selectors';
import { ActiveSubtenantsSelector } from 'invision-core/src/components/subtenants/subtenants.selectors';
import { setForceShowEditFormAddress, validateAddress } from '../../../reducers/actions/address.component.actions';
import { CurrentCustomerSelector, EnableProspectLiteSelector } from '../../../reducers/selectors/customer.selectors';
import { registerUnsavedChanges, unregisterUnsavedChanges } from 'invision-core/src/components/unsavedChangesPrompt/actions';
import { getShippingMethodsByCountryCode } from 'invision-core/src/components/metadata/shippingMethods/shipping.methods.actions';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { DELIVERY_OPTIONS, DUPLICATE_SERVICE_IDENTIFIER_FAULT_CODE, INSUFFICIENT_CREDIT_AMOUNT_FAULT_CODE, INVENTORY_ITEM_RESERVATION_FAULT_CODE, NOTIFICATION_TIME_LENGTH, ORDER_SCENARIOS, RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION } from '../../../customercare.constants';
import { AllAttributesAreValidSelector, AttributeServiceSelector, BackButtonTextSelector, CurrentActiveAttributeNameSelector, FilteredFormAttributeGroups, FilteredPhysicalAttributeGroups, FinancedProductGroupInCartSelector, FormAttributeGroups, FormPhysicalAttributeGroups, ForwardButtonTextSelector, GroupedCheckboxFilterOptionsSelector, HasRequiredAndUnavailableInventorySelector, IsContinueDisabledSelector, IsContinueShoppingShownSelector, IsFetchingAnyDataSelector, IsSaveOrderButtonDisabledSelector, IsShippingRequiredSelector, OfferOptionViewModelSelector, ShippingAddressDropdownOptionsSelector, ShippingAddressSelector, ShowNextButtonSelector, ShowPreviousButtonSelector, StepProgressBarViewModelSelector, SummaryTabViewModel, UnavailablePhysicalInventorySelector } from './new.connect.wizard.selectors';
import { AllPhysicalInventoryItemsFromSelectedOffering, AreAnyInventoryUnavailableSelector, AttributeFormSubmittedSelector, CartContainsOffcycleOfferSelector, CartContainsOfferWithBillerRuleCycleLevelOtherThanItemSelector, CompletedDecisionsSelector, DecisionsHasErrorSelector, FilteredStoresOnSelectedRegionForStoresSearchModalSelector, HasOffCycleChargeRenewalSelector, IsAllSelectedPhysicalInventoryPresentAtSelectedStore, InventoryAvailabilitySelector, IsSelectedOfferingChangeable, IsSendToStoreButtonEnabledSelector, IsUpdatingCartSelector, PagesIsFetchingDataSelector, PaymentInstrumentRequiredSelector, SelectedDeliveryDecisionFromRocSelector, SelectedOfferingPhysicalInventoryAvailabilitySelector, SelectedOfferingServiceIdentifiersSelector, SelectedOfferingStoreAvailabilitySelector, ShoppingCartHaveOnlyStandaloneItemsSelector, ShoppingCartIsPostpaidSelector, ShoppingCartSelector, SubmittedOrderErrorSelector } from '../../../reducers/selectors/selected.offering.order.selectors';
import { AddressDataSelector, PreventOverrideFlagSelector } from '../../../reducers/selectors/customer.addresses.selectors';
import { beginNewConnectOrder, cancelOrder, clearQuoteAndSetSelectedOffer, createCustomer, createCustomerAndSaveOrder, createCustomerAndSendOrderToStore, fetchAttributes, fetchAttributesAndNavigate, fetchDecisionsAndNavigate, goToNextStep, goToPreviousStep, goToStep, navigateToFetchOffers, restoreOptionDefaultPricing, retrieveCandidateBillCyclesNewConnect, saveBulkPricing, saveOrder, searchAttributeInventory, sendOrderToStore, sendPortInOrItemReservation, setCurrentStepIsInvalid, setEditAttributeGroups, setEditCartAdditionalProperty, setEditCartAdditionalPropertyOnChange, setEditOfferAdditionalProperty, setEditOfferAdditionalPropertyOnChange, setEditOption, setEditOrderAdditionalProperty, setEditOrderAdditionalPropertyOnChange, setEditPhysicalAttributeGroups, setPaymentInfo, setSelectedFacetsEditCopy, setSelectedOfferEditCopy, setSelectedOfferingChargeTypesEditCopy, setSelectedTab, submitOrder, updateAttribute, updateBillCycle, updateCart, updateCustomer, updateAddress, updateCustomerAndSaveOrder, updateCustomerAndSendOrderToStore, updateCustomerAndSubmitOrder, updateCustomerInfo, updateCustomerInfoEditCopy, updateEditOptionPrice, updateInventorySelection, updateOfferPhysicalInventoryMakeAndModel, updateOfferPhysicalInventoryTypeAttribute, updatePaymentInfo, updatePortInRequest, updateSelectedServiceFeatures } from '../../../reducers/actions/new.connect.wizard.actions';
import { calculateOfferingOrderQuote, resetAvailableInventoryInformation, retrieveOffCycleNextRenewalSchedules, retrieveOfferingOrderQuote, retrieveOrderQuote, saveInventoryStorePickupDetails, searchAvailableOfferings, searchInventoriesAvailability, setActiveAttributeFormName, setAttributeFormSubmitted, setDeliveryDecision, setDevicePaymentOptions, setInventoryRegionFilter, setInventoryStoreChangedFlag, setSelectedInventoryStores, updateServiceTaxLocationDecision } from '../../../reducers/actions/offering.order.actions';
import { initializeAsMultiOfferWizard, setChangeOfferingId, setChangeOfferingInstanceId } from '../../../reducers/actions/add.offer.wizard.actions';
import { setCreditCheckModalStatus, resetSubscriberCreditClassification } from '../../../reducers/actions/credit.check.actions';
import { AvailableCreditLimitFromQuoteSelector, AvailableFinanceCreditFromQuoteSelector, BillCycleSelector, BillingAddressStateRegionProvinceValueOptionsSelector, CartAdditionalPropertiesSelector, CartAdditionalPropertyListMapSelector, CompletedStepsSelector, ConvergentBillerAccountsSelector, CreatedCustomerSelector, CreatedCustomerCreditLimitSelector, CurrentCustomerIsExternallyManagedARSelector, CurrentStepIndexSelector, CurrentStepIsInvalidSelector, CurrentStepSelector, CustomerInfoSelector, DeliveryOptionsByPricingPlanSelector, EditOptionSelector, EditOptionsSelector, EditCustomerInfoIsCategoryValidSelector, EditCustomerInfoSelector, EditCustomerInfoSubtenantSelector, EditSelectedFacetIdsSelector, EditSelectedOfferingChargeTypeIdSelector, FormattedAttributesSelector, FormattedCityStateSelector, FormattedDeliveryDecisionsSelector, FormattedNameSelector, FormattedPhysicalAttributesSelector, GetSubtenantNameSelector, HasCustomerInfoSelector, InventoryAvailabilityRequestsSelector, IsAttributesStepSelector, IsCheckoutStepSelector, IsCreatingOrUpdatingCustomerSelector, IsCreditLimitBreachedFromQuoteSelector, IsCustomerStepSelector, IsDecisionsStepSelector, IsFetchingBillCyclesSelector, IsFetchingDataSelector, IsOffersStepSelector, IsPopoutableSelector, IsServiceabilityStepSelector, NewConnectCandidateBillCyclesSelector, NewConnectOfferDeliveryMethodOptionsSelector, OfferAdditionalPropertiesSelector, OfferAdditionalPropertyListMapSelector, OrderAdditionalPropertiesSelector, OrderAdditionalPropertyListMapSelector, PaymentInfoEditAutoPaySelector, PaymentInfoEditSelector, PaymentInfoSelector, QuoteHasInvoiceItemsSelector, SelectedOfferIdSelector, SelectedTabIndexSelector, ServiceTaxDecisionsSelector, TabPanelViewModelSelector, TaxLocationDecisionsByPricingPlanSelector, ViewLastAttemptErrorSelector } from '../../../reducers/selectors/new.connect.wizard.selectors';
import { RecordPaymentInformationSelector } from '../../../reducers/selectors/customer.ewallet.selectors';
import { getPreviousStepIndex } from '../../../reducers/helpers/wizard.helper';
import { buildSegmentationContext, duplicatedServiceIdentifierAttributes } from '../../../reducers/helpers/offer.ordering.wizard.helper';
import { searchContracts } from '../../../reducers/actions/contracts.list.actions';
import { CreatedOrderCurrencyCodeSelector, CreatedOrderSelector, DbssShippingEnabledRegionIdSelector, FullCartAsyncStatusSelector, InventoryStorePickupDetailsSelector, InventoryStoresTableDataSelector, IsFetchingSelector as IsFetchingOfferSelector, IsFullCartAsyncCompleteSelector, IsAsyncCompleteSelector, IsInventoryStoreChangedSelector, IsInventoryStoreConfiguredSelector, IsQuoteBypassedSelector, IsQuotingOfferSelector, IsSendingInventoryToStoreSelector, IsSubmittingOrderSelector, OffcycleRenewalScheduleSelector, OfferingOrderAsyncIdSelector, OfferingOrderQuoteSelector, QuoteCalculatedSelector, SelectedDeliveryDecisionSelector, SelectedInventoryRegionSelector, SelectedInventoryStoresDetailsSelector, SelectedOrderDetailsSelector, SelectedOrderExecutionOptionsSelector, SelectedShippingAddressAndMethodSelector, ViewLastAttemptErrorSelector as OfferingOrderLastAttemptErrorSelector } from '../../../reducers/selectors/offering.order.selectors';
import { SelectedContractSelector } from '../../../reducers/selectors/contract.selectors';
import { CurrentBusinessUnitHasSubtenants } from '../../../reducers/selectors/subtenant.selectors';
import { ALL_STEPS_KEYS, STATE_OR_NAME } from '../../../reducers/constants/new.connect.wizard.constants';
import { ContextOfferingAction } from '../../../reducers/constants/wizard.constants';
import CustomerCareKeys from '../../../locales/keys';
import { getErrorLookupObject } from '../../createCustomer/create.customer.constants';
import { searchSubtenants, updateSubscriberBillCycle } from '../../../reducers/actions/customer.actions';
import { ContractsSearchResultsSelector } from '../../../reducers/selectors/contracts.list.selectors';
import { CustomerCategories } from '../../createCustomerPopup/create.customer.popup.constants';
import { ADD_OFFER_ORDER_URL } from '../../customer/orders/create/offer/add.offer.wizard.module';
import { resetMobileNumberPortabilityModels } from '../../../reducers/actions/mobile.number.portability.actions';
import { CustomerTypesByCategoryOptionsSelector } from '../../createCustomerPopup/customer.form.dropdown.selectors';
import { ValidatedAddressesSelector, UnvalidatedAddressesSelector } from '../../../reducers/selectors/address.component.selectors';
import { FullCartOfferingOrderQuotesSelector, FullCartOfferingOrderQuoteTotalSelector, FullCartOfferingOrderFeeQuoteSelector, FullCartOfferingOrderTaxQuoteSelector, FullCartOfferingOrderShippingQuoteSelector, ShowHideFullCartColumnsSelector } from '../../../reducers/selectors/full.cart.selectors';
import { formatValidatedAddress, isAddressValidFromAddressResponse } from '../../shared/contextualComponents/address/address.validator.helper';
import { OfferWizard } from '../../customer/orders/offer.wizard.common';
import { MINI_CART_MORE_ACTIONS, moreActionMenuItems } from '../tabs/summaryTab/summary.tab.helper';
import { asyncRepeatInterval } from '../../../reducers/helpers/async.helper';
import { FormattedNewCustomerSubscriberIdentitiesSelector } from '../../../reducers/selectors/customer.information.selectors';
export var NewConnectWizardController = /*#__PURE__*/function (_OfferWizard) {
  function NewConnectWizardController($scope, $ngRedux, $log, $filter, $state, $location, $anchorScroll, $timeout, $interval, $element, formErrors, uiNotificationService, unsavedChangesPrompt) {
    var _this;
    _classCallCheck(this, NewConnectWizardController);
    _this = _callSuper(this, NewConnectWizardController);
    Object.assign(_this, {
      $anchorScroll: $anchorScroll,
      $element: $element,
      $filter: $filter,
      $interval: $interval,
      $location: $location,
      $log: $log,
      $ngRedux: $ngRedux,
      $scope: $scope,
      $state: $state,
      $timeout: $timeout,
      contextOfferingAction: ContextOfferingAction.ADD,
      CoreLocaleKeys: CoreLocaleKeys,
      customerCareKeys: CustomerCareKeys,
      DELIVERY_OPTIONS: DELIVERY_OPTIONS,
      formErrors: formErrors,
      isInventoryItemReservationFault: false,
      orderScenario: ORDER_SCENARIOS.NEW_CONNECT,
      overrideBypassQuoteConfiguration: false,
      retrieveOfferingOrderQuoteTimestamp: null,
      retrieveOrderQuoteTimestamp: null,
      showSendToStorePopup: false,
      STATE_OR_NAME: STATE_OR_NAME,
      uiNotificationService: uiNotificationService,
      unsavedChangesPrompt: unsavedChangesPrompt,
      attemptNextStep: _this.attemptNextStep.bind(_this),
      changeOfferClick: _this.changeOfferClick.bind(_this),
      closeSearchInventoryPopupDialog: _this.closeSearchInventoryPopupDialog.bind(_this),
      closeSelectStorePopupDialog: _this.closeSelectStorePopupDialog.bind(_this),
      closeSendToStorePopup: _this.closeSendToStorePopup.bind(_this),
      closeViewFullCartPopupDialog: _this.closeViewFullCartPopupDialog.bind(_this),
      editOfferClick: _this.editOfferClick.bind(_this),
      fetchQuoteNewConnect: _this.fetchQuoteNewConnect.bind(_this),
      getAddressKey: _this.getAddressKey.bind(_this),
      goToPreviousStep: _this.goToPreviousStep.bind(_this),
      handleCloseCurrencyMismatchErrorPopup: _this.handleCloseCurrencyMismatchErrorPopup.bind(_this),
      handleCloseSaveOrderErrorPopup: _this.handleCloseSaveOrderErrorPopup.bind(_this),
      handleCloseSubmitOrderErrorPopup: _this.handleCloseSubmitOrderErrorPopup.bind(_this),
      handleInventoryAvailabilityContinue: _this.handleInventoryAvailabilityContinue.bind(_this),
      handleOpenSubmitOrderErrorPopup: _this.handleOpenSubmitOrderErrorPopup.bind(_this),
      handleResultUnsavedChangesPromptPopup: _this.handleResultUnsavedChangesPromptPopup.bind(_this),
      onCartAdditionalPropertyChanged: _this.onCartAdditionalPropertyChanged.bind(_this),
      onCartAdditionalPropertyListUpdated: _this.onCartAdditionalPropertyListUpdated.bind(_this),
      onInventoryRegionFilterChanged: _this.onInventoryRegionFilterChanged.bind(_this),
      onInventoryRegionFilterChangedForStoreSearch: _this.onInventoryRegionFilterChangedForStoreSearch.bind(_this),
      onMoreActionSelected: _this.onMoreActionSelected.bind(_this),
      onOfferSelected: _this.onOfferSelected.bind(_this),
      onAdditionalPropertyChanged: _this.onAdditionalPropertyChanged.bind(_this),
      onAdditionalPropertyListUpdated: _this.onAdditionalPropertyListUpdated.bind(_this),
      onOverrideCalculateQuote: _this.onOverrideCalculateQuote.bind(_this),
      onRefreshOfferingQuote: _this.onRefreshOfferingQuote.bind(_this),
      onRefreshQuote: _this.onRefreshQuote.bind(_this),
      onSelectInventoryStore: _this.onSelectInventoryStore.bind(_this),
      openStoreSearch: _this.openStoreSearch.bind(_this),
      recallOfferingContext: _this.recallOfferingContext.bind(_this),
      repeatRetrieveOfferingQuote: _this.repeatRetrieveOfferingQuote.bind(_this),
      repeatRetrieveQuote: _this.repeatRetrieveQuote.bind(_this),
      sendToStore: _this.sendToStore.bind(_this),
      setSelectedStoreForSearchModal: _this.setSelectedStoreForSearchModal.bind(_this),
      submitOrderMessageError: null,
      tabSelected: _this.tabSelected.bind(_this),
      updateCart: _this.updateCart.bind(_this),
      validateAddressWithAPI: _this.validateAddressWithAPI.bind(_this)
    });
    return _this;
  }
  _inherits(NewConnectWizardController, _OfferWizard);
  return _createClass(NewConnectWizardController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var codeTables = [CODES.InventoryRegion, CODES.OneTimeBillerRuleConfiguration, CODES.PeriodType, CODES.ReasonCodes, CODES.RecurringBillerRuleConfiguration, CODES.Stores, CODES.SubscriberType, CODES.SubscriberTypeSecurityRole];
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          additionalPropValueOptions: MetadataCodeTypeIntegerSelector(CODES.AdditionalPropertyValue, store),
          addressData: AddressDataSelector(store),
          addressStates: BillingAddressStateRegionProvinceValueOptionsSelector(store),
          allAttributesAreValid: AllAttributesAreValidSelector(store),
          areAnyInventoryUnavailable: AreAnyInventoryUnavailableSelector(store),
          attributeFormSubmitted: AttributeFormSubmittedSelector(store),
          availableCreditLimitFromQuote: AvailableCreditLimitFromQuoteSelector(store),
          availableFinanceCreditFromQuote: AvailableFinanceCreditFromQuoteSelector(store),
          availableInventoryInformation: InventoryAvailabilitySelector(store),
          backButtonText: BackButtonTextSelector(store),
          billCycle: BillCycleSelector(store),
          candidateBillCycles: NewConnectCandidateBillCyclesSelector(store),
          cartAdditionalProperties: CartAdditionalPropertiesSelector(store),
          cartAdditionalPropertyListMap: CartAdditionalPropertyListMapSelector(store),
          cartContainsOfferWithBillerRuleCycleLevelOtherThanItem: CartContainsOfferWithBillerRuleCycleLevelOtherThanItemSelector(store),
          cartContainsOffcycleOffer: CartContainsOffcycleOfferSelector(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          completedDecisions: CompletedDecisionsSelector(store),
          completedSteps: CompletedStepsSelector(store),
          contracts: ContractsSearchResultsSelector(store),
          convergentBillerAccounts: ConvergentBillerAccountsSelector(store),
          createdCustomer: CreatedCustomerSelector(store),
          createdCustomerCreditLimit: CreatedCustomerCreditLimitSelector(store),
          createdOrder: CreatedOrderSelector(store),
          createOrderError: OfferingOrderLastAttemptErrorSelector(store),
          createUpdateCustomerError: ViewLastAttemptErrorSelector(store),
          currencyCode: CreatedOrderCurrencyCodeSelector(store),
          currentAttributeTitle: CurrentActiveAttributeNameSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerIsExternallyManagedAR: CurrentCustomerIsExternallyManagedARSelector(store),
          currentStep: CurrentStepSelector(store),
          currentStepIndex: CurrentStepIndexSelector(store),
          currentStepIsInvalid: CurrentStepIsInvalidSelector(store),
          currentSubtenants: ActiveSubtenantsSelector(store),
          customerInfo: CustomerInfoSelector(store),
          customerInfoEdit: EditCustomerInfoSelector(store),
          customerInfoEditIsCategoryValid: EditCustomerInfoIsCategoryValidSelector(store),
          customerInfoEditSubtenant: EditCustomerInfoSubtenantSelector(store),
          customerTypesByCategory: CustomerTypesByCategoryOptionsSelector(store),
          dbssShippingEnabledRegionId: DbssShippingEnabledRegionIdSelector(store),
          deliveryMethodOptions: NewConnectOfferDeliveryMethodOptionsSelector(store),
          deliveryOptionsByPricingPlan: DeliveryOptionsByPricingPlanSelector(store),
          editOption: EditOptionSelector(store),
          editOptions: EditOptionsSelector(store),
          enableProspectLite: EnableProspectLiteSelector(store),
          executionOptions: SelectedOrderExecutionOptionsSelector(store),
          filteredFormAttributeGroups: FilteredFormAttributeGroups(store),
          filteredPhysicalAttributeGroups: FilteredPhysicalAttributeGroups(store),
          filteredStoresOnSelectedRegionForStoresSearchModal: FilteredStoresOnSelectedRegionForStoresSearchModalSelector(store),
          financedProductGroupInCart: FinancedProductGroupInCartSelector(store),
          formattedAttributes: FormattedAttributesSelector(store),
          formattedCityState: FormattedCityStateSelector(store),
          formattedDeliveryDecisions: FormattedDeliveryDecisionsSelector(store),
          formattedName: FormattedNameSelector(store),
          formattedPhysicalAttributes: FormattedPhysicalAttributesSelector(store),
          formattedPhysicalInventories: SelectedOfferingPhysicalInventoryAvailabilitySelector(store),
          formattedNewCustomerSubscriberIdentities: FormattedNewCustomerSubscriberIdentitiesSelector(store).asMutable({
            deep: true
          }),
          formAttributeGroups: FormAttributeGroups(store),
          formPhysicalAttributeGroups: FormPhysicalAttributeGroups(store),
          forwardButtonText: ForwardButtonTextSelector(store),
          fullCartAsyncStatus: FullCartAsyncStatusSelector(store),
          fullCartOfferingOrderQuotes: FullCartOfferingOrderQuotesSelector(store),
          fullCartOfferingOrderQuoteTotal: FullCartOfferingOrderQuoteTotalSelector(store),
          fullCartOfferingOrderFeeQuote: FullCartOfferingOrderFeeQuoteSelector(store),
          fullCartOfferingOrderTaxQuote: FullCartOfferingOrderTaxQuoteSelector(store),
          fullCartOfferingOrderShippingQuote: FullCartOfferingOrderShippingQuoteSelector(store),
          getSubtenantName: GetSubtenantNameSelector(store),
          groupedCheckboxFilterOptions: GroupedCheckboxFilterOptionsSelector(store),
          hasCustomerInfo: HasCustomerInfoSelector(store),
          hasDecisionValidationError: DecisionsHasErrorSelector(store),
          hasInvoiceItems: QuoteHasInvoiceItemsSelector(store),
          hasOffCycleChargeRenewal: HasOffCycleChargeRenewalSelector(store),
          hasRequiredAndUnavailableInventory: HasRequiredAndUnavailableInventorySelector(store),
          hasSubtenantsCurrently: CurrentBusinessUnitHasSubtenants(store),
          isDbss: IsDbss(store),
          inventoryAvailabilityRequests: InventoryAvailabilityRequestsSelector(store),
          inventoryRegions: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.InventoryRegion, store),
          inventoryStorePickupDetails: InventoryStorePickupDetailsSelector(store),
          isAllSelectedPhysicalInventoryAvailable: IsAllSelectedPhysicalInventoryPresentAtSelectedStore(store),
          isAttributesStep: IsAttributesStepSelector(store),
          isCheckoutStep: IsCheckoutStepSelector(store),
          isContinueDisabled: IsContinueDisabledSelector(store),
          isContinueShoppingShown: IsContinueShoppingShownSelector(store),
          isCreatingOrUpdatingCustomer: IsCreatingOrUpdatingCustomerSelector(store),
          isCreditLimitBreached: IsCreditLimitBreachedFromQuoteSelector(store),
          isCustomerStep: IsCustomerStepSelector(store),
          isDecisionsStep: IsDecisionsStepSelector(store),
          isFetchingAnyData: IsFetchingAnyDataSelector(store),
          isFetchingBillCycles: IsFetchingBillCyclesSelector(store),
          isFetchingData: IsFetchingDataSelector(store),
          isFetchingDecisionsOrAttributes: PagesIsFetchingDataSelector(store),
          isFetchingOffer: IsFetchingOfferSelector(store),
          isFullCartAsyncComplete: IsFullCartAsyncCompleteSelector(store),
          isInventoryStoreChanged: IsInventoryStoreChangedSelector(store),
          isInventoryStoreConfigured: IsInventoryStoreConfiguredSelector(store),
          isOffersStep: IsOffersStepSelector(store),
          isPaymentInstrumentRequired: PaymentInstrumentRequiredSelector(store),
          isPopoutable: IsPopoutableSelector(store),
          isQuoteBypassed: IsQuoteBypassedSelector(store),
          isQuoteCalculated: QuoteCalculatedSelector(store),
          isAsyncComplete: IsAsyncCompleteSelector(store),
          isQuotingOffer: IsQuotingOfferSelector(store),
          isSaveOrderButtonDisabled: IsSaveOrderButtonDisabledSelector(store),
          isSelectedOfferingChangeable: IsSelectedOfferingChangeable(store),
          isSendingInventoryToStore: IsSendingInventoryToStoreSelector(store),
          isSendToStoreButtonEnabled: IsSendToStoreButtonEnabledSelector(store),
          isServiceabilityStep: IsServiceabilityStepSelector(store),
          isShippingRequired: IsShippingRequiredSelector(store),
          isSubmittingOrder: IsSubmittingOrderSelector(store),
          isUpdatingCart: IsUpdatingCartSelector(store),
          lastAttemptError: SubmittedOrderErrorSelector(store),
          lastRoute: LastRouteSelector(store),
          offcycleRenewalSchedule: OffcycleRenewalScheduleSelector(store),
          offerAdditionalProperties: OfferAdditionalPropertiesSelector(store),
          offerAdditionalPropertyListMap: OfferAdditionalPropertyListMapSelector(store),
          offeringOrderAsyncId: OfferingOrderAsyncIdSelector(store),
          offeringOrderQuote: OfferingOrderQuoteSelector(store),
          offerOptionViewModel: OfferOptionViewModelSelector(store),
          orderAdditionalProperties: OrderAdditionalPropertiesSelector(store),
          orderAdditionalPropertyListMap: OrderAdditionalPropertyListMapSelector(store),
          orderDetails: SelectedOrderDetailsSelector(store),
          pageSize: PageSizePreferenceSelector(store),
          paymentInfo: PaymentInfoSelector(store),
          paymentInfoEdit: PaymentInfoEditSelector(store),
          paymentInfoEditAutoPay: PaymentInfoEditAutoPaySelector(store),
          periodTypes: MetadataCodeTypeSelector(CODES.PeriodType, store),
          physicalInventories: AllPhysicalInventoryItemsFromSelectedOffering(store),
          preventOverrideFlag: PreventOverrideFlagSelector(store),
          recordPaymentInfo: RecordPaymentInformationSelector(store),
          rocWarningTranslatedMessage: ROCWarningTranslatedMessageSelector(store),
          selectedContract: SelectedContractSelector(store),
          selectedDeliveryDecision: SelectedDeliveryDecisionSelector(store),
          selectedDeliveryDecisionFromRoc: SelectedDeliveryDecisionFromRocSelector(store),
          selectedInventoryRegion: SelectedInventoryRegionSelector(store),
          selectedInventoryStores: SelectedInventoryStoresDetailsSelector(store),
          selectedInventoryStoresItemAvailability: SelectedOfferingStoreAvailabilitySelector(store),
          selectedOfferId: SelectedOfferIdSelector(store),
          selectedOfferingServiceIdentifiers: SelectedOfferingServiceIdentifiersSelector(store),
          selectedShippingAddressAndMethod: SelectedShippingAddressAndMethodSelector(store),
          selectedTabIndex: SelectedTabIndexSelector(store),
          services: AttributeServiceSelector(store),
          serviceTaxDecisions: ServiceTaxDecisionsSelector(store),
          shippingAddress: ShippingAddressSelector(store),
          shippingAddressDropdownOptions: ShippingAddressDropdownOptionsSelector(store),
          shoppingCart: ShoppingCartSelector(store),
          shoppingCartHaveOnlyStandaloneItems: ShoppingCartHaveOnlyStandaloneItemsSelector(store),
          shoppingCartIsPostpaid: ShoppingCartIsPostpaidSelector(store),
          shouldShowNextButton: ShowNextButtonSelector(store),
          shouldShowPreviousButton: ShowPreviousButtonSelector(store),
          showHideFullCartColumns: ShowHideFullCartColumnsSelector(store),
          stepsProgressBarViewModel: StepProgressBarViewModelSelector(store),
          storesTableData: InventoryStoresTableDataSelector(store),
          summaryTabViewModel: SummaryTabViewModel(store),
          tabs: TabPanelViewModelSelector(store),
          taxLocationDecisionsByPricingPlan: TaxLocationDecisionsByPricingPlanSelector(store),
          unavailablePhysicalInventory: UnavailablePhysicalInventorySelector(store),
          unvalidatedAddresses: UnvalidatedAddressesSelector(store),
          validatedAddresses: ValidatedAddressesSelector(store)
        };
      };
      var controllerActions = {
        beginNewConnectOrder: beginNewConnectOrder,
        calculateOfferingOrderQuote: calculateOfferingOrderQuote,
        cancelOrder: cancelOrder,
        clearQuoteAndSetSelectedOffer: clearQuoteAndSetSelectedOffer,
        createCustomer: createCustomer,
        createCustomerAndSaveOrder: createCustomerAndSaveOrder,
        createCustomerAndSendOrderToStore: createCustomerAndSendOrderToStore,
        fetchAttributes: fetchAttributes,
        fetchAttributesAndNavigate: fetchAttributesAndNavigate,
        fetchCodeTypes: fetchCodeTypes,
        fetchDecisionsAndNavigate: fetchDecisionsAndNavigate,
        getShippingMethodsByCountryCode: getShippingMethodsByCountryCode,
        goToNextStep: goToNextStep,
        goToPreviousStep: goToPreviousStep,
        goToStep: goToStep,
        initializeAsMultiOfferWizard: initializeAsMultiOfferWizard,
        navigateToFetchOffers: navigateToFetchOffers,
        registerUnsavedChanges: registerUnsavedChanges,
        resetAvailableInventoryInformation: resetAvailableInventoryInformation,
        resetMobileNumberPortabilityModels: resetMobileNumberPortabilityModels,
        resetSubscriberCreditClassification: resetSubscriberCreditClassification,
        restoreOptionDefaultPricing: restoreOptionDefaultPricing,
        retrieveCandidateBillCyclesNewConnect: retrieveCandidateBillCyclesNewConnect,
        retrieveOffCycleNextRenewalSchedules: retrieveOffCycleNextRenewalSchedules,
        retrieveOfferingOrderQuote: retrieveOfferingOrderQuote,
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveOrderQuote: retrieveOrderQuote,
        saveBulkPricing: saveBulkPricing,
        saveInventoryStorePickupDetails: saveInventoryStorePickupDetails,
        saveOrder: saveOrder,
        searchAttributeInventory: searchAttributeInventory,
        searchAvailableOfferings: searchAvailableOfferings,
        searchContracts: searchContracts,
        searchInventoriesAvailability: searchInventoriesAvailability,
        searchSubtenants: searchSubtenants,
        sendOrderToStore: sendOrderToStore,
        sendPortInOrItemReservation: sendPortInOrItemReservation,
        setActiveAttributeFormName: setActiveAttributeFormName,
        setAttributeFormSubmitted: setAttributeFormSubmitted,
        setChangeOfferingId: setChangeOfferingId,
        setChangeOfferingInstanceId: setChangeOfferingInstanceId,
        setCreditCheckModalStatus: setCreditCheckModalStatus,
        setCurrentStepIsInvalid: setCurrentStepIsInvalid,
        setDeliveryDecision: setDeliveryDecision,
        setDevicePaymentOptions: setDevicePaymentOptions,
        setEditAttributeGroups: setEditAttributeGroups,
        setEditCartAdditionalProperty: setEditCartAdditionalProperty,
        setEditCartAdditionalPropertyOnChange: setEditCartAdditionalPropertyOnChange,
        setEditOfferAdditionalProperty: setEditOfferAdditionalProperty,
        setEditOption: setEditOption,
        setEditOrderAdditionalProperty: setEditOrderAdditionalProperty,
        setEditOrderAdditionalPropertyOnChange: setEditOrderAdditionalPropertyOnChange,
        setEditPhysicalAttributeGroups: setEditPhysicalAttributeGroups,
        setForceShowEditFormAddress: setForceShowEditFormAddress,
        setInventoryRegionFilter: setInventoryRegionFilter,
        setInventoryStoreChangedFlag: setInventoryStoreChangedFlag,
        setPaymentInfo: setPaymentInfo,
        setSelectedFacetsEditCopy: setSelectedFacetsEditCopy,
        setSelectedInventoryStores: setSelectedInventoryStores,
        setSelectedOfferEditCopy: setSelectedOfferEditCopy,
        setSelectedOfferingChargeTypesEditCopy: setSelectedOfferingChargeTypesEditCopy,
        setSelectedTab: setSelectedTab,
        submitOrder: submitOrder,
        unregisterUnsavedChanges: unregisterUnsavedChanges,
        updateAddress: updateAddress,
        updateAttribute: updateAttribute,
        setEditOfferAdditionalPropertyOnChange: setEditOfferAdditionalPropertyOnChange,
        updateBillCycle: updateBillCycle,
        updateCart: updateCart,
        updateCustomer: updateCustomer,
        updateCustomerAndSaveOrder: updateCustomerAndSaveOrder,
        updateCustomerAndSendOrderToStore: updateCustomerAndSendOrderToStore,
        updateCustomerAndSubmitOrder: updateCustomerAndSubmitOrder,
        updateCustomerInfo: updateCustomerInfo,
        updateCustomerInfoEditCopy: updateCustomerInfoEditCopy,
        updateEditOptionPrice: updateEditOptionPrice,
        updateInventorySelection: updateInventorySelection,
        updateOfferPhysicalInventoryMakeAndModel: updateOfferPhysicalInventoryMakeAndModel,
        updateOfferPhysicalInventoryTypeAttribute: updateOfferPhysicalInventoryTypeAttribute,
        updateOverrideFlag: updateOverrideFlag,
        updatePaymentInfo: updatePaymentInfo,
        updatePortInRequest: updatePortInRequest,
        updateSelectedServiceFeatures: updateSelectedServiceFeatures,
        updateServiceTaxLocationDecision: updateServiceTaxLocationDecision,
        updateSubscriberBillCycle: updateSubscriberBillCycle,
        validateAddress: validateAddress
      };
      this.disconnectRedux = this.connectToStore(mapStateToTarget, controllerActions);
      this.EditSelectedFacetIdsSelector = EditSelectedFacetIdsSelector;
      this.EditSelectedOfferingChargeTypeIdSelector = EditSelectedOfferingChargeTypeIdSelector;
      this.customerFormErrors = [];
      this.cartMessages = [CustomerCareKeys.CART_SUMMARY.QUOTE_SUMMARY];
      this.actions.beginNewConnectOrder();
      this.actions.resetSubscriberCreditClassification();
      this.customerCategories = CustomerCategories();

      // Used to see if Contracts exist if changed, also change in AddOfferWizard
      this.actions.searchContracts({
        PageNumber: 1,
        PageSize: 1
      });
      codeTables.forEach(function (codeType) {
        if (!_this2.state.codeTypeLoaded(codeType)) {
          _this2.actions.fetchCodeTypes(codeType).catch(function (error) {
            _this2.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      });
      this.actions.searchSubtenants().then(function () {}).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
      this.$scope.orderConfirmationPopup = {
        onRegisterApi: function onRegisterApi(evt) {
          _this2.$scope.orderConfirmationPopup = evt.api;
        }
      };

      // hook the popupApi
      this.additionalPropertiesPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this2.additionalPropertiesPopupApi = api;
        }
      };
      this.currencyMismatchErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this2.currencyMismatchErrorPopupApi = api;
        }
      };
      this.unsavedChangesPromptPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this2.unsavedChangesPromptPopupApi = api;
        }
      };
      this.saveOrderErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref4) {
          var api = _ref4.api;
          _this2.saveOrderErrorPopupApi = api;
        }
      };
      this.submitOrderErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref5) {
          var api = _ref5.api;
          _this2.submitOrderErrorPopupApi = api;
        }
      };
      this.saveOrderPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref6) {
          var api = _ref6.api;
          _this2.saveOrderPopupApi = api;
        }
      };
      this.sendToStorePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref7) {
          var api = _ref7.api;
          _this2.sendToStorePopupApi = api;
        }
      };
      this.creditCheckPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref8) {
          var api = _ref8.api;
          _this2.creditCheckPopupApi = api;
        }
      };
      this.selectStorePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref9) {
          var api = _ref9.api;
          _this2.selectStorePopupApi = api;
        }
      };
      this.storeSearchInventoryConfig = {
        onRegisterApi: function onRegisterApi(_ref10) {
          var api = _ref10.api;
          _this2.storeSearchInventoryApi = api;
        }
      };
      this.openCreditCheckModal = function () {
        _this2.creditCheckPopupApi.open();
      };
      this.viewFullCartPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.viewFullCartPopupApi = event.api;
        }
      };
    }
  }, {
    key: "openSendToStorePopup",
    value: function openSendToStorePopup() {
      var _this3 = this;
      this.sendToStorePickupDetailsConfig = {
        maxDate: undefined,
        minDate: Date.now()
      };
      this.showSendToStorePopup = true;
      this.$timeout(function () {
        _this3.sendToStorePopupApi.open();
      });
    }

    //Calls retrieveOrderQuote the first time and then calls it every 30 seconds that the call hasnt returned a response
  }, {
    key: "repeatRetrieveQuote",
    value: function repeatRetrieveQuote() {
      var _this4 = this;
      asyncRepeatInterval(this.onRefreshQuote, function () {
        return !_this4.state.isAsyncComplete && _this4.state.isCheckoutStep;
      });
    }
  }, {
    key: "onRefreshQuote",
    value: function onRefreshQuote() {
      var _this5 = this;
      return this.actions.retrieveOfferingOrderQuote(this.state.createdCustomer.Subscriber.Id, this.state.offeringOrderAsyncId).then(function (response) {
        _this5.retrieveOrderQuoteTimestamp = moment().add(RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION, 'milliseconds');
        return response;
      }).catch(function (error) {
        _this5.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "repeatRetrieveOfferingQuote",
    value: function repeatRetrieveOfferingQuote() {
      var _this6 = this;
      if (this.state.offeringOrderQuote.OfferingQuotes.length > 0 && this.state.isFullCartAsyncComplete) {
        this.openViewFullCartPopupDialog();
      } else {
        asyncRepeatInterval(this.onRefreshOfferingQuote, function () {
          return !_this6.state.isFullCartAsyncComplete && _this6.state.isCheckoutStep;
        });
      }
    }
  }, {
    key: "onRefreshOfferingQuote",
    value: function onRefreshOfferingQuote() {
      var _this7 = this;
      return this.actions.retrieveOfferingOrderQuote(this.state.createdCustomer.Subscriber.Id, this.state.offeringOrderAsyncId).then(function (response) {
        _this7.retrieveOfferingOrderQuoteTimestamp = moment().add(RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION, 'milliseconds');
        return response;
      }).catch(function (error) {
        return _this7.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "openViewFullCartPopupDialog",
    value: function openViewFullCartPopupDialog() {
      this.showViewFullCartPopup = true;
      this.$timeout(this.viewFullCartPopupApi.open);
    }
  }, {
    key: "onViewFullCartRequest",
    value: function onViewFullCartRequest() {
      var _this8 = this;
      if (this.state.offeringOrderAsyncId) {
        this.repeatRetrieveOfferingQuote();
        this.openViewFullCartPopupDialog();
      } else {
        if (!Object.keys(this.state.offeringOrderQuote).length) {
          this.actions.calculateOfferingOrderQuote(this.state.customerInfo, this.state.shoppingCart, this.state.billCycle, this.state.executionOptions, this.state.selectedShippingAddressAndMethod, undefined, this.overrideBypassQuoteConfiguration).then(function () {
            _this8.openViewFullCartPopupDialog();
            if (_this8.state.cartContainsOffcycleOffer) {
              _this8.actions.retrieveOffCycleNextRenewalSchedules(_this8.state.createdCustomer.Subscriber.Id, _this8.state.shoppingCart.Items).catch(function (error) {
                _this8.uiNotificationService.transientError(error.translatedMessage);
              });
            }
          }).catch(function (error) {
            _this8.uiNotificationService.transientError(error.translatedMessage);
          });
        } else {
          this.openViewFullCartPopupDialog();
          if (this.state.cartContainsOffcycleOffer) {
            this.actions.retrieveOffCycleNextRenewalSchedules(this.state.createdCustomer.Subscriber.Id, this.state.shoppingCart.Items).catch(function (error) {
              _this8.uiNotificationService.transientError(error.translatedMessage);
            });
          }
        }
      }
    }
  }, {
    key: "closeViewFullCartPopupDialog",
    value: function closeViewFullCartPopupDialog() {
      this.showViewFullCartPopup = false;
      this.viewFullCartPopupApi.close();
    }
  }, {
    key: "sendToStore",
    value: function sendToStore() {
      var _this9 = this;
      this.isLoading = true;
      this.actions.updateCustomerInfo(this.state.customerInfoEdit);
      var shoppingCart = this.state.cartAdditionalProperties.length ? Object.assign({}, this.state.shoppingCart, {
        AdditionalProperties: this.state.cartAdditionalProperties
      }) : this.state.shoppingCart;
      var createOrUpdateCustomerAndSendOrderToStorePromise = !this.state.createdCustomer ? this.state.isCheckoutStep ? this.actions.sendOrderToStore(this.state.createdCustomer, shoppingCart, this.state.inventoryStorePickupDetails) : this.actions.createCustomerAndSendOrderToStore(this.state.customerInfo, shoppingCart, this.state.inventoryStorePickupDetails, this.state.preventOverrideFlag) : this.state.isCheckoutStep ? this.actions.sendOrderToStore(this.state.createdCustomer, shoppingCart, this.state.inventoryStorePickupDetails) : this.actions.updateCustomerAndSendOrderToStore(this.state.createdCustomer, this.state.customerInfo, shoppingCart, this.state.inventoryStorePickupDetails);
      createOrUpdateCustomerAndSendOrderToStorePromise.then(function () {
        _this9.actions.unregisterUnsavedChanges('$ctrl.sendToStoreForm');
        _this9.actions.updateOverrideFlag(null);
        _this9.onSaveOrderSuccess(CustomerCareKeys.SEND_TO_STORE.SEND_SUCCESS);
      }).catch(function (error) {
        if (error.Code === INVENTORY_ITEM_RESERVATION_FAULT_CODE) {
          _this9.closeSendToStorePopup();
          _this9.isInventoryItemReservationFault = true;
          _this9.openStoreSearch(true);
        } else {
          _this9.uiNotificationService.transientError(error.translatedMessage);
        }
      }).finally(function () {
        _this9.isLoading = false;
      });
    }
  }, {
    key: "launchSaveOrder",
    value: function launchSaveOrder() {
      var _this10 = this;
      if (this.state.cartAdditionalPropertyListMap.length) {
        this.cartAdditionalPropertyFileds = clone(this.state.cartAdditionalPropertyListMap);
        this.showAdditionalPropertiesPopup = true;
        this.$timeout(function () {
          _this10.additionalPropertiesPopupApi.open();
        });
      } else {
        this.finishSaveOrder();
      }
    }
  }, {
    key: "closeAdditionalPropertiesPopup",
    value: function closeAdditionalPropertiesPopup() {
      this.showAdditionalPropertiesPopup = false;
      this.additionalPropertiesPopupApi.close();
    }
  }, {
    key: "saveAdditionalProperties",
    value: function saveAdditionalProperties() {
      if (this.additionalPropertiesPopupForm.$valid) {
        this.showAdditionalPropertiesPopup = false;
        this.additionalPropertiesPopupApi.close();
        this.finishSaveOrder();
      } else {
        var old = this.$location.hash();
        this.$location.hash('additionalPropertiesErrorField');
        this.$anchorScroll();
        this.$location.hash(old);
      }
    }
  }, {
    key: "onCartAdditionalPropertyListUpdated",
    value: function onCartAdditionalPropertyListUpdated() {
      this.actions.setEditCartAdditionalProperty(this.state.cartAdditionalPropertyListMap);
    }
  }, {
    key: "onCartAdditionalPropertyChanged",
    value: function onCartAdditionalPropertyChanged(id, newValue) {
      this.actions.setEditCartAdditionalPropertyOnChange(id, newValue);
    }
  }, {
    key: "onAdditionalPropertyListUpdated",
    value: function onAdditionalPropertyListUpdated(isOfferAdditionalProperty) {
      if (isOfferAdditionalProperty) {
        this.actions.setEditOfferAdditionalProperty(this.state.offerAdditionalPropertyListMap);
      } else {
        this.actions.setEditOrderAdditionalProperty(this.state.orderAdditionalPropertyListMap);
      }
    }
  }, {
    key: "onAdditionalPropertyChanged",
    value: function onAdditionalPropertyChanged(id, newValue, isOfferAdditionalProperty) {
      if (isOfferAdditionalProperty) {
        this.actions.setEditOfferAdditionalPropertyOnChange(id, newValue);
      } else {
        this.actions.setEditOrderAdditionalPropertyOnChange(id, newValue);
      }
    }
  }, {
    key: "openOrderConfirmationPopup",
    value: function openOrderConfirmationPopup() {
      this.$scope.orderConfirmationPopup.open();
    }
  }, {
    key: "redirectToCustomer",
    value: function redirectToCustomer() {
      this.$scope.orderConfirmationPopup.close();
      this.deregisterUnsavedChanges();
      this.$state.go(CUSTOMER_URL, {
        'customerId': this.state.createdCustomer.Subscriber.Id,
        'showAutoPayBanner': {
          enabled: this.state.paymentInfoEditAutoPay,
          customerId: this.state.createdCustomer.Subscriber.Id
        }
      });
    }
  }, {
    key: "updateCart",
    value: function updateCart(offerId) {
      var offeringInstanceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var completedDecisions = arguments.length > 2 ? arguments[2] : undefined;
      var isModify = arguments.length > 3 ? arguments[3] : undefined;
      var customerId = arguments.length > 4 ? arguments[4] : undefined;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      var contextOfferingAction = arguments.length > 6 ? arguments[6] : undefined;
      var transitionContext = arguments.length > 7 ? arguments[7] : undefined;
      var isConvergentBiller = arguments.length > 8 ? arguments[8] : undefined;
      var customerLanguage = arguments.length > 9 ? arguments[9] : undefined;
      this.actions.setDevicePaymentOptions([]);

      /**
      * Updates the cart, also handles the user language
      * @param {string} offerId
      * @param {number} offeringInstanceId
      * @param {[]} completedDecisions
      * @param {boolean} isModify
      * @param {number} customerId
      * @param {number} contextOfferingAction
      * @param {Object} transitionContext
      * @param {boolean} isConvergentBiller
      * @param {string} customerLanguage
      */

      /**Callback function as paramater
       *  @callback callback
      */

      this.actions.updateCart(offerId, offeringInstanceId, completedDecisions, isModify, customerId, callback, contextOfferingAction, transitionContext, isConvergentBiller, customerLanguage);
    }
  }, {
    key: "handleResultUnsavedChangesPromptPopup",
    value: function handleResultUnsavedChangesPromptPopup(confirmed) {
      if (confirmed) {
        this.handleCancel();
      }
      this.unsavedChangesPromptPopupApi.close();
    }
  }, {
    key: "handleCloseCurrencyMismatchErrorPopup",
    value: function handleCloseCurrencyMismatchErrorPopup() {
      this.currencyMismatchErrorPopupApi.close();
    }
  }, {
    key: "handleCloseUnsavedChangesPromptPopup",
    value: function handleCloseUnsavedChangesPromptPopup() {
      this.unsavedChangesPromptPopupApi.close();
    }
  }, {
    key: "handleCloseSaveOrderErrorPopup",
    value: function handleCloseSaveOrderErrorPopup() {
      this.saveOrderErrorPopupApi.close();
    }
  }, {
    key: "handleOpenSubmitOrderErrorPopup",
    value: function handleOpenSubmitOrderErrorPopup() {
      var totalQuote = pathOr(null, ['summaryTabViewModel', 'totalQuoteAmount'], this.state);
      var creditLimit = pathOr(null, ['currentCustomer', 'CreditCheckClassification', 'CreditLimit'], this.state);
      var breachedAmount = totalQuote && creditLimit ? creditLimit - totalQuote : null;
      this.submitOrderMessageError = breachedAmount ? i18n.translate(CustomerCareKeys.CREDIT_LIMIT_BREACHED, {
        breachAmount: this.$filter('invCurrency')(breachedAmount, this.state.currentCustomer.SubscriberCurrency)
      }) : i18n.translate(CustomerCareKeys.CREDIT_LIMIT_BREACHED_NO_AMOUNT);
      this.submitOrderErrorPopupApi.open();
    }
  }, {
    key: "handleCloseSubmitOrderErrorPopup",
    value: function handleCloseSubmitOrderErrorPopup() {
      this.submitOrderErrorPopupApi.close();
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.actions.cancelOrder();
      this.deregisterUnsavedChanges();
      var route = this.state.lastRoute.name || 'index.customercare';
      var params = this.state.lastRoute.params || {};
      this.$state.go(route, params);
    }
  }, {
    key: "deregisterUnsavedChanges",
    value: function deregisterUnsavedChanges() {
      this.actions.unregisterUnsavedChanges('serviceabilityController.serviceabilityForm');
      // no "offers" form
      // no "decisions" form
      this.actions.unregisterUnsavedChanges('attributesController.attributesForm');
      this.actions.unregisterUnsavedChanges('customerController.customerForm');
      this.actions.unregisterUnsavedChanges('$ctrl.paymentInstrumentForm');
      this.actions.unregisterUnsavedChanges('newConnectWizard');
      this.actions.resetMobileNumberPortabilityModels();
    }
  }, {
    key: "previousStepIsOffersStep",
    value: function previousStepIsOffersStep() {
      return getPreviousStepIndex(ALL_STEPS_KEYS, this.state.completedSteps, this.state.currentStepIndex) === 1;
    }
  }, {
    key: "goToPreviousStep",
    value: function goToPreviousStep() {
      if (this.state.isCustomerStep) {
        this.customerFormErrors = [];
        this.actions.updateCustomerInfo(this.state.customerInfoEdit);
      } else if (this.state.isCheckoutStep) {
        this.actions.setPaymentInfo(this.state.paymentInfoEdit);
      }
      if (this.state.isAttributesStep && this.isAttributesFormInvalid()) {
        this.wizardForm.$setSubmitted();
        this.actions.setAttributeFormSubmitted(true);
        return;
      }
      this.actions.goToPreviousStep();
      if (this.state.isDecisionsStep) {
        this.actions.setAttributeFormSubmitted(false);
        this.actions.setActiveAttributeFormName(null);
      }
    }
  }, {
    key: "cancelClick",
    value: function cancelClick() {
      if (this.unsavedChangesPrompt.hasUnsavedChanges()) {
        this.unsavedChangesPromptPopupApi.open();
      } else {
        this.handleCancel();
      }
    }
  }, {
    key: "fetchQuoteNewConnect",
    value: function fetchQuoteNewConnect(customerInfo) {
      var _this11 = this;
      this.actions.calculateOfferingOrderQuote(customerInfo, this.state.shoppingCart, this.state.billCycle, undefined, this.state.selectedShippingAddressAndMethod, !!this.state.shippingAddress, this.overrideBypassQuoteConfiguration).then(function () {
        if (_this11.state.offeringOrderAsyncId) {
          _this11.repeatRetrieveQuote();
        }
      }).catch(function (error) {
        _this11.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onSaveOrderSuccess",
    value: function onSaveOrderSuccess() {
      var messageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CustomerCareKeys.SAVE_ORDER_FORM.SUCCESS;
      this.uiNotificationService.success(i18n.translate(messageKey), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
      this.redirectToCustomer();
    }
  }, {
    key: "onCreditCheckModalSuccess",
    value: function onCreditCheckModalSuccess() {
      this.updateStateValues = !this.updateStateValues;
    }
  }, {
    key: "onOfferSelected",
    value: function onOfferSelected(offerId) {
      var _this12 = this;
      this.actions.fetchDecisionsAndNavigate({
        offerId: offerId,
        skipAttributesTargetStep: CustomerCareKeys.WIZARD.STEPS.CUSTOMER,
        isConvergentBiller: true,
        segmentationContext: buildSegmentationContext(this.state.customerInfoEdit)
      }).then(function () {
        _this12.wizardForm.$setPristine();
        _this12.actions.retrieveOfferingsMetadata([offerId]);
        _this12.miniCartMoreActionMenuItems = moreActionMenuItems(_this12.state.isSelectedOfferingChangeable ? [MINI_CART_MORE_ACTIONS.EDIT_SINGLE_OFFER, MINI_CART_MORE_ACTIONS.CHANGE] : [MINI_CART_MORE_ACTIONS.EDIT_SINGLE_OFFER]);
      });
    }
  }, {
    key: "saveOrderButtonTooltipText",
    value: function saveOrderButtonTooltipText() {
      var tooltipText = '';
      if (!(this.state.shoppingCart.Items && this.state.shoppingCart.Items.length)) {
        tooltipText = i18n.translate(CustomerCareKeys.SAVE_CART.CART_IS_EMPTY);
      } else if (this.state.shoppingCartHaveOnlyStandaloneItems) {
        tooltipText = i18n.translate(CustomerCareKeys.SAVE_CART.CART_IS_HAVING_ONLY_STANDALONE_PRODUCTS);
      }
      return tooltipText;
    }
  }, {
    key: "closeSendToStorePopup",
    value: function closeSendToStorePopup() {
      this.showSendToStorePopup = false;
      this.sendToStorePopupApi.close();
      this.isLoading = false;
    }
  }, {
    key: "finishSaveOrder",
    value: function finishSaveOrder() {
      var _this13 = this;
      if (this.state.isCheckoutStep) {
        var paymentInfo = this.state.recordPaymentInfo ? this.state.paymentInfoEdit && this.state.paymentInfoEdit.asMutable() : null;
        if (this.state.recordPaymentInfo && paymentInfo && !paymentInfo.BillingAddress) {
          paymentInfo.BillingAddress = {
            Name: this.state.customerInfoEdit.addressLine1,
            City: this.state.customerInfoEdit.city,
            Country: this.state.customerInfoEdit.country,
            LineOne: this.state.customerInfoEdit.addressLine1,
            LineTwo: this.state.customerInfoEdit.addressLine2,
            PostalCode: this.state.customerInfoEdit.postalCode,
            State: this.state.customerInfoEdit.stateRegionProvince
          };
        }
        var shoppingCart = this.state.cartAdditionalProperties.length ? Object.assign({}, this.state.shoppingCart, {
          AdditionalProperties: this.state.cartAdditionalProperties
        }) : this.state.shoppingCart;
        return this.actions.saveOrder(this.state.createdCustomer, shoppingCart).then(function () {
          _this13.onSaveOrderSuccess();
        }).catch(function (err) {
          _this13.saveOrderErrorPopupApi.open(err);
          return Promise.reject();
        });
      } else if ((this.state.isDecisionsStep || this.state.isServiceabilityStep || this.state.isOffersStep) && this.state.hasDecisionValidationError) {
        this.uiNotificationService.error(i18n.translate(CustomerCareKeys.INVALID_ORDER_SAVE), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
        if (this.state.isDecisionsStep) {
          var old = this.$location.hash();
          this.$location.hash('quantityDecisionErrorField');
          this.$anchorScroll();
          this.$location.hash(old);
        }
      } else {
        this.actions.fetchAttributes({
          offeringId: this.state.selectedOfferId,
          completedDecisions: this.getCompletedDecisions(),
          completedAttributes: this.state.formattedAttributes,
          completedPhysicalAttributes: this.state.formattedPhysicalAttributes
        }).then(function () {
          _this13.wizardForm.$submitted = true;
          if (!duplicatedServiceIdentifierAttributes(_this13.state.formAttributeGroups).length) {
            _this13.attemptNextStep(false, false, true);
          }
        }).catch(function (error) {
          _this13.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }

    // temporary until all steps do validation the same
  }, {
    key: "isContinueDisabled",
    value: function isContinueDisabled() {
      return this.state.isFetchingAnyData || this.state.isSubmittingOrder || this.state.isCreatingOrUpdatingCustomer || this.state.isServiceabilityStep && !this.state.customerInfoEdit.SubscriberCurrency || this.isLoading;
    }
  }, {
    key: "isServiceabilityFormInvalid",
    value: function isServiceabilityFormInvalid() {
      return this.wizardForm['serviceabilityController.serviceabilityForm'] && this.wizardForm['serviceabilityController.serviceabilityForm'].$invalid;
    }
  }, {
    key: "isOffersStepInvalid",
    value: function isOffersStepInvalid() {
      return this.state.currentStepIsInvalid;
    }
  }, {
    key: "isAttributesFormInvalid",
    value: function isAttributesFormInvalid() {
      return this.wizardForm['attributesController.attributesForm'] && this.wizardForm['attributesController.attributesForm'].$invalid || !this.state.allAttributesAreValid;
    }
  }, {
    key: "isCheckoutFormInvalid",
    value: function isCheckoutFormInvalid() {
      return this.wizardForm['$ctrl.paymentInstrumentForm'] && this.wizardForm['$ctrl.paymentInstrumentForm'].$invalid;
    }
  }, {
    key: "isCustomerFormInvalid",
    value: function isCustomerFormInvalid() {
      return this.wizardForm['customerController.customerForm'] && this.wizardForm['customerController.customerForm'].$invalid;
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      var _this14 = this;
      var isAddAnotherOffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.removeMultiOfferValidations = this.state.enableProspectLite && isAddAnotherOffer;
      // time out is added for lite customer validations on customer step
      this.$timeout(function () {
        if (!_this14.state.isCreatingOrUpdatingCustomer && !_this14.state.isSubmittingOrder && !_this14.isLoading) {
          // This is a unique case in which we need a local loading variable to immediately disable the continue button
          // Chained actions in continue to next step exposes small gaps in which each action isLoading selector do not cover
          // Therefore we need this to prevent first prevent that as well as faster disabling of the button as we are seeing
          // delay as the selectors start to toggle their isLoading flags
          _this14.isLoading = true;
          _this14.wizardForm.$setSubmitted();
          if (!isAddAnotherOffer) {
            _this14.$element.find('button[type="submit"]')[0].focus();
          }
          _this14.attemptNextStep(isAddAnotherOffer);
        }
      });
    }
  }, {
    key: "addAnotherOfferOrSaveCart",
    value: function addAnotherOfferOrSaveCart(isSaveCart) {
      var _this15 = this;
      if (!this.state.createdCustomer) {
        this.actions.createCustomerAndSaveOrder(this.state.customerInfoEdit, this.state.shoppingCart, null, null, null, this.state.preventOverrideFlag).then(function () {
          _this15.deregisterUnsavedChanges();
          _this15.actions.initializeAsMultiOfferWizard(true);
          _this15.actions.updateOverrideFlag(null);
          _this15.$state.go(isSaveCart ? DASHBOARD_ROUTE : ADD_OFFER_ORDER_URL, {
            'customerId': _this15.state.createdCustomer.Subscriber.Id
          });
        }).catch(function (error) {
          _this15.uiNotificationService.transientError(error.translatedMessage);
          // Intentionally not setting isLoading to false on .finally() due to it loading other api calls through the
          // process of transitioning to the add flow wizard
          _this15.isLoading = false;
        });
      } else {
        this.actions.updateCustomerAndSaveOrder(this.state.createdCustomer, this.state.customerInfo, this.state.shoppingCart).then(function () {
          _this15.deregisterUnsavedChanges();
          _this15.actions.initializeAsMultiOfferWizard(true);
          _this15.$state.go(ADD_OFFER_ORDER_URL, {
            'customerId': _this15.state.createdCustomer.Subscriber.Id
          });
        });
      }
    }
  }, {
    key: "recallOfferingContext",
    value: function recallOfferingContext() {
      var _this16 = this;
      this.actions.fetchAttributes({
        offeringId: this.state.selectedOfferId,
        completedDecisions: this.getCompletedDecisions(),
        completedAttributes: this.state.formattedAttributes,
        completedPhysicalAttributes: this.state.formattedPhysicalAttributes
      }).catch(function (err) {
        _this16.uiNotificationService.transientError(err.translatedMessage);
      });
    }
  }, {
    key: "getCompletedDecisions",
    value: function getCompletedDecisions() {
      return [].concat(_toConsumableArray(this.state.serviceTaxDecisions), _toConsumableArray(this.state.formattedDeliveryDecisions), _toConsumableArray(this.state.completedDecisions));
    }
  }, {
    key: "attemptNextStep",
    value: function attemptNextStep() {
      var _this17 = this;
      var isAddAnotherOffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isSendToStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isSaveCart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var dirty = true;
      this.removeMultiOfferValidations = this.state.enableProspectLite && (isSendToStore || isAddAnotherOffer || isSaveCart);
      // NOTE: this may register non-existant (extraneous) "unsaved
      // changes" in the case that the user tries to proceed to the next
      // step, but has not dirtied the form
      this.actions.registerUnsavedChanges('newConnectWizard', {
        isDirty: function isDirty() {
          return dirty;
        },
        setPristine: function setPristine() {
          dirty = false;
        }
      });
      if (this.state.isServiceabilityStep) {
        if (!this.isServiceabilityFormInvalid()) {
          if (this.state.isDbss) {
            this.actions.getShippingMethodsByCountryCode(this.state.addressData.address.Country).catch(function (error) {
              _this17.uiNotificationService.transientError(error.translatedMessage);
            });
          }
          if (this.shouldValidateAddressWithAPIForServiceability()) {
            this.validateAddressWithAPI().then(function () {
              var addressKey = _this17.getAddressKey(),
                validatedAddress = _this17.state.validatedAddresses[addressKey];
              _this17.isLoading = false;
              if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
                _this17.updateCustomerInfoEditWithValidatedAddress(validatedAddress && validatedAddress.ValidatedAddress);
                return _this17.proceedToFetchOffers();
              } else {
                _this17.actions.setForceShowEditFormAddress(false);
                return Promise.resolve();
              }
            }).catch(function (err) {
              _this17.uiNotificationService.transientError(err.translatedMessage);
            }).finally(function () {
              _this17.isLoading = false;
            });
          } else {
            this.proceedToFetchOffers().finally(function () {
              _this17.isLoading = false;
            });
          }
        } else {
          this.isLoading = false;
        }
      } else if (this.state.isOffersStep) {
        if (!this.isOffersStepInvalid()) {
          this.isLoading = false;
          this.actions.goToNextStep();
          this.wizardForm.$setPristine();
        } else {
          this.isLoading = false;
        }
      } else if (this.state.isAttributesStep && !this.state.hasRequiredAndUnavailableInventory) {
        this.actions.setAttributeFormSubmitted(true);
        if (!this.isAttributesFormInvalid() && !duplicatedServiceIdentifierAttributes(this.state.formAttributeGroups).length) {
          if (this.state.formattedPhysicalAttributes.length) {
            this.actions.resetAvailableInventoryInformation();
            this.actions.fetchAttributes({
              offeringId: this.state.selectedOfferId,
              completedDecisions: this.getCompletedDecisions(),
              completedAttributes: this.state.formattedAttributes,
              completedPhysicalAttributes: this.state.formattedPhysicalAttributes
            }).then(function () {
              if (_this17.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED) {
                _this17.actions.setInventoryRegionFilter(_this17.state.dbssShippingEnabledRegionId);
              }
              if (_this17.state.selectedInventoryStores.length < 1) {
                _this17.openStoreSearch();
                _this17.wizardForm.$setPristine();
                _this17.isLoading = false;
              } else {
                _this17.actions.searchInventoriesAvailability(_this17.state.formattedPhysicalInventories).then(function () {
                  if (!_this17.state.isAllSelectedPhysicalInventoryAvailable) {
                    if (_this17.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED) {
                      _this17.uiNotificationService.transientError(i18n.translate(CustomerCareKeys.ATTRIBUTES.UNAVAILABLE_SHIPPING_INVENTORY));
                    } else {
                      _this17.openStoreSearch();
                    }
                  } else {
                    _this17.fetchAttributesAndNavigate();
                  }
                }).then(function () {
                  _this17.wizardForm.$setPristine();
                }).catch(function (err) {
                  _this17.showStoreInventoryPopup = true;
                  _this17.$timeout(function () {
                    _this17.storeSearchInventoryApi.open();
                    _this17.onSearchInventoryAvailabilityFailure(err);
                  });
                }).finally(function () {
                  _this17.isLoading = false;
                });
              }
            }).catch(function (error) {
              _this17.isLoading = false;
              if (error.Code !== DUPLICATE_SERVICE_IDENTIFIER_FAULT_CODE) {
                _this17.uiNotificationService.transientError(error.translatedMessage);
              }
            });
          } else {
            this.fetchAttributesAndNavigate();
          }
        } else {
          this.isLoading = false;
        }
      } else if (this.state.isCheckoutStep) {
        this.isLoading = true;
        this.disableStepBack = true;
        if (isAddAnotherOffer) {
          this.addAnotherOfferOrSaveCart();
        } else if (isSendToStore) {
          this.openSendToStorePopup();
        } else {
          if (!this.isCheckoutFormInvalid()) {
            this.validateAddressWithAPI().then(function () {
              var addressKey = _this17.getAddressKey(),
                validatedAddress = _this17.state.validatedAddresses[addressKey];
              _this17.isLoading = false;
              if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
                _this17.updateCustomerInfoEditWithValidatedAddress(validatedAddress && validatedAddress.ValidatedAddress);
                _this17.actions.updateCustomerInfo(_this17.state.customerInfoEdit);
                _this17.actions.setPaymentInfo(_this17.state.paymentInfoEdit);
                if (_this17.state.createdCustomer) {
                  // if the customer has already been created, then call updateCustomer
                  var dto = {
                    additionalProperties: _this17.state.orderAdditionalProperties,
                    billCycleName: _this17.state.billCycle,
                    convergentBillerAccounts: _this17.state.convergentBillerAccounts,
                    customerId: _this17.state.createdCustomer.Subscriber.Id,
                    executionOptions: _this17.state.executionOptions,
                    newCustomerData: _this17.state.customerInfo,
                    orderDetails: _this17.state.orderDetails,
                    oldCustomerData: _this17.state.createdCustomer,
                    paymentInfo: _this17.state.paymentInfo,
                    recordPaymentInfo: _this17.state.recordPaymentInfo,
                    shoppingCart: _this17.state.shoppingCart,
                    subtenantId: _this17.state.customerInfo.SubtenantId,
                    offerAdditionalProperties: _this17.state.offerAdditionalProperties
                  };
                  if (_this17.state.createdCustomerCreditLimit) {
                    _this17.checkCreditandFinanceLimitAndSubmitOrder(dto);
                  } else {
                    _this17.submitOrder(dto);
                  }
                }
              } else {
                _this17.actions.setForceShowEditFormAddress(false);
                _this17.uiNotificationService.transientError(i18n.translate(_this17.customerCareKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE));
              }
            }).catch(function (err) {
              _this17.uiNotificationService.transientError(err.translatedMessage);
              _this17.isLoading = false;
            });
          } else {
            this.isLoading = false;
          }
        }
      } else if (this.state.isCustomerStep) {
        if (!this.isCustomerFormInvalid()) {
          this.validateAddressWithAPI().then(function () {
            var addressKey = _this17.getAddressKey();
            var validatedAddress = _this17.state.validatedAddresses[addressKey];
            _this17.isLoading = false;
            if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
              _this17.updateCustomerInfoEditWithValidatedAddress(validatedAddress && validatedAddress.ValidatedAddress);
              _this17.isLoading = true;
              _this17.actions.setForceShowEditFormAddress(false);
              if (isAddAnotherOffer || isSaveCart) {
                _this17.addAnotherOfferOrSaveCart(isSaveCart);
              } else if (isSendToStore) {
                _this17.openSendToStorePopup();
              } else {
                _this17.actions.updateCustomerInfo(_this17.state.customerInfoEdit);
                _this17.createOrUpdateCustomerCalculateOrderQuoteAndNavigate();
              }
            } else {
              _this17.actions.setForceShowEditFormAddress(false);
              _this17.customerFormErrors.push({
                description: i18n.translate(CustomerCareKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE)
              });
            }
          }).catch(function (err) {
            _this17.isLoading = false;
            _this17.uiNotificationService.transientError(err.translatedMessage);
          });
        } else {
          //Customer step
          // time out is added for lite customer validations on customer step
          this.$timeout(function () {
            var ngFormErrors = _this17.wizardForm['customerController.customerForm'].createCustomerForm.$error;
            var errorLookups = getErrorLookupObject();
            _this17.customerFormErrors = formHasErrors(ngFormErrors, errorLookups);

            //TODO ASC-103364. this is temporary fix to get errors from address component. Reference story should add error handling in the component and remove his workaround.
            _this17.formErrors.flattenedErrors(ngFormErrors).reduce(function (customerFormErrors, _ref11) {
              var error = _ref11.error,
                constraintType = _ref11.constraintType;
              if (!errorLookups[error.$name]) {
                var errorMessage = _this17.formErrors.getErrorMessage(error, constraintType, {});
                errorMessage && customerFormErrors.push({
                  description: errorMessage
                });
              }
              return customerFormErrors;
            }, _this17.customerFormErrors);
          });
          this.isLoading = false;
          this.scrollToErrorSummary();
        }
      } else if (this.state.isDecisionsStep && !this.state.currentStepIsInvalid && !this.state.hasDecisionValidationError) {
        this.actions.fetchAttributesAndNavigate({
          offerId: this.state.selectedOfferId,
          completedDecisions: this.getCompletedDecisions(),
          completedAttributes: this.state.formattedAttributes
        }).then(function () {
          if (_this17.state.selectedDeliveryDecision && _this17.state.selectedDeliveryDecision !== _this17.state.selectedDeliveryDecisionFromRoc) {
            _this17.actions.setDeliveryDecision(_this17.state.selectedDeliveryDecisionFromRoc);
            _this17.actions.setSelectedInventoryStores([]);
          }
          _this17.wizardForm.$setPristine();
        }).catch(function (error) {
          _this17.uiNotificationService.transientError(error.translatedMessage);
        }).finally(function () {
          _this17.isLoading = false;
        });
      } else {
        this.$log.warn('The current step has errors');
        this.isLoading = false;
      }
    }
  }, {
    key: "checkCreditandFinanceLimitAndSubmitOrder",
    value: function checkCreditandFinanceLimitAndSubmitOrder(dto) {
      var isFinanceCreditLimitBreached = this.validateFinanceCreditLimitFromQuote();
      if (!this.state.isCreditLimitBreached && !isFinanceCreditLimitBreached && dto) {
        this.updateCustomerSubmitOrder(dto);
      } else {
        this.isLoading = false;
      }
    }
  }, {
    key: "checkCreditAndFinanceLimit",
    value: function checkCreditAndFinanceLimit(dto) {
      var isFinanceCreditLimitBreached = this.validateFinanceCreditLimitFromQuote();
      if (!this.state.isCreditLimitBreached && !isFinanceCreditLimitBreached && dto) {
        this.updateCustomer(dto);
      } else {
        this.isLoading = false;
      }
    }
  }, {
    key: "createOrUpdateCustomerCalculateOrderQuoteAndNavigate",
    value: function createOrUpdateCustomerCalculateOrderQuoteAndNavigate() {
      var _this18 = this;
      if (!this.state.createdCustomer) {
        // if the customer hasn't been created yet, then call createCustomer
        this.actions.createCustomer(this.state.customerInfo, this.state.preventOverrideFlag).then(function (data) {
          _this18.calculateOrderQuoteAndCheckCreditAndFinanceLimit(true);
          _this18.actions.unregisterUnsavedChanges('newConnectWizard');
          _this18.actions.updateOverrideFlag(null);
          _this18.actions.updateCustomerInfoEditCopy(Object.assign({}, _this18.state.customerInfoEdit, {
            Id: data.Subscriber.Id
          }));
        }).catch(function (error) {
          _this18.isLoading = false;
          _this18.uiNotificationService.transientError(error.translatedMessage);
        });
      } else {
        // if the customer has been created , then call updateCustomer
        this.actions.updateCustomer(this.state.createdCustomer, this.state.customerInfo).then(function () {
          _this18.calculateOrderQuoteAndCheckCreditAndFinanceLimit();
          return _this18.actions.updateAddress(_this18.state.createdCustomer, _this18.state.customerInfo);
        }).catch(function (error) {
          _this18.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "calculateOrderQuoteAndCheckCreditAndFinanceLimit",
    value: function calculateOrderQuoteAndCheckCreditAndFinanceLimit() {
      var _this19 = this;
      var isCreateCustomer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.calculateQuoteAndNavigate(isCreateCustomer).then(function () {
        _this19.checkCreditAndFinanceLimit();
      }).catch(function (error) {
        _this19.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this19.isLoading = false;
      });
    }
  }, {
    key: "validateFinanceCreditLimitFromQuote",
    value: function validateFinanceCreditLimitFromQuote() {
      return this.state.availableFinanceCreditFromQuote > 0;
    }
  }, {
    key: "submitOrder",
    value: function submitOrder(dto) {
      var _this20 = this;
      this.actions.submitOrder(dto, this.state.selectedShippingAddressAndMethod).then(function () {
        _this20.actions.unregisterUnsavedChanges('newConnectWizard');
        _this20.$scope.orderConfirmationPopup.open();
        _this20.actions.resetMobileNumberPortabilityModels();
      }).catch(function (error) {
        _this20.isLoading = false;
        if (error.Code && error.Code === INSUFFICIENT_CREDIT_AMOUNT_FAULT_CODE) {
          _this20.handleOpenSubmitOrderErrorPopup();
          return;
        }
        _this20.submitOrderErrorPopupApi.open(error);
      });
    }
  }, {
    key: "updateCustomerSubmitOrder",
    value: function updateCustomerSubmitOrder(dto) {
      var _this21 = this;
      this.actions.updateCustomerAndSubmitOrder(dto, this.state.selectedShippingAddressAndMethod).then(function () {
        _this21.actions.unregisterUnsavedChanges('newConnectWizard');
        _this21.$scope.orderConfirmationPopup.open();
        _this21.actions.resetMobileNumberPortabilityModels();
      }).catch(function (error) {
        _this21.isLoading = false;
        if (error.Code && error.Code === INSUFFICIENT_CREDIT_AMOUNT_FAULT_CODE) {
          _this21.handleOpenSubmitOrderErrorPopup();
          return;
        }
        _this21.submitOrderErrorPopupApi.open(error);
      });
    }
  }, {
    key: "scrollToErrorSummary",
    value: function scrollToErrorSummary() {
      var _this22 = this;
      this.$timeout(function () {
        // needed because of the continue shopping button can not submit the angular form
        var old = _this22.$location.hash();
        _this22.$location.hash('createCustomerForm');
        _this22.$anchorScroll();
        _this22.$location.hash(old);
      });
    }
  }, {
    key: "calculateQuoteAndNavigate",
    value: function calculateQuoteAndNavigate(isCreateCustomer) {
      var _this23 = this;
      return Promise.resolve().then(function () {
        if (_this23.state.cartContainsOfferWithBillerRuleCycleLevelOtherThanItem) {
          // RetrieveCandidateBillCycles should  only be called in DBSS. New Connect currently is not supported in OTT.
          return _this23.actions.retrieveCandidateBillCyclesNewConnect(_this23.state.shoppingCartIsPostpaid ? subscriberOrderTypeEnum.postpaid.value : subscriberOrderTypeEnum.prepaid.value, _this23.state.customerInfo.Category, _this23.state.customerInfo.SubscriberCurrency, _this23.state.customerInfo.SubscriberTypeCode, _this23.state.customerInfo.country, _this23.state.customerInfo.stateRegionProvince);
        }
      }).then(function (data) {
        if (isCreateCustomer) {
          var _data$BillCycles$;
          _this23.actions.updateSubscriberBillCycle(data === null || data === void 0 ? void 0 : (_data$BillCycles$ = data.BillCycles[0]) === null || _data$BillCycles$ === void 0 ? void 0 : _data$BillCycles$.Id, _this23.state.createdCustomer.Subscriber.Id);
        }
      }).then(function () {
        _this23.actions.updateCustomerInfo(_this23.state.customerInfoEdit);
      }).then(function () {
        if (_this23.state.customerInfo.SubscriberCurrency !== _this23.state.shoppingCart.Currency) {
          _this23.currencyMismatchErrorPopupApi.open();
        } else {
          if (_this23.state.createdCustomer) {
            return _this23.fetchQuote(_this23.state.createdCustomer.Subscriber);
          } else {
            return _this23.fetchQuote(_this23.state.customerInfo);
          }
        }
      }).catch(function (error) {
        _this23.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "fetchQuote",
    value: function fetchQuote(custInfo) {
      var _this24 = this;
      return this.actions.calculateOfferingOrderQuote(custInfo, this.state.shoppingCart, undefined, undefined, undefined, this.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED, this.overrideBypassQuoteConfiguration).then(function () {
        if (_this24.state.offeringOrderAsyncId) {
          _this24.repeatRetrieveQuote();
        }
        _this24.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT);
        _this24.customerFormErrors = [];
        _this24.wizardForm.$setPristine();
      }).catch(function (error) {
        _this24.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "handleInventoryAvailabilityContinue",
    value: function handleInventoryAvailabilityContinue() {
      /*
          if inventoryavailability not there then show the stores
          slash status icons
      */
      this.wizardForm.$setPristine();
      this.fetchAttributesAndNavigate();
    }
  }, {
    key: "fetchAttributesAndNavigate",
    value: function fetchAttributesAndNavigate() {
      var _this25 = this;
      return this.actions.fetchAttributesAndNavigate({
        offerId: this.state.selectedOfferId,
        completedDecisions: this.getCompletedDecisions(),
        completedAttributes: this.state.formattedAttributes,
        completedPhysicalAttributes: this.state.formattedPhysicalAttributes,
        skipAttributesTargetStep: this.state.customerInfoEdit.Language
      }).then(function () {
        _this25.wizardForm.$setPristine();
      }).catch(function (error) {
        _this25.uiNotificationService.transientError(error.translatedMessage);
        return Promise.reject();
      }).finally(function () {
        _this25.isLoading = false;
      });
    }
  }, {
    key: "tabSelected",
    value: function tabSelected(selectedTab) {
      var selectedIndex = this.state.tabs.findIndex(function (tab) {
        return tab === selectedTab;
      });
      this.actions.setSelectedTab(selectedIndex);
    }
  }, {
    key: "onSelectInventoryStore",
    value: function onSelectInventoryStore() {
      var _this26 = this;
      if (this.state.isCustomerStep || this.state.isCheckoutStep) {
        this.openStoreSearch(true);
      } else {
        if (this.state.selectedInventoryRegion) {
          this.actions.setInventoryRegionFilter(this.state.selectedInventoryRegion);
        }
        this.showSelectStorePopup = true;
        this.$timeout(function () {
          _this26.selectStorePopupApi.open();
        });
      }
    }

    // Handles only single offer flow.
  }, {
    key: "_updateShoppingCartOnInventoryStoreChange",
    value: function _updateShoppingCartOnInventoryStoreChange() {
      var _this27 = this;
      if ((this.state.isCustomerStep || this.state.isCheckoutStep) && this.state.isInventoryStoreChanged) {
        var selectedOfferingInstanceId = undefined;
        return this.actions.fetchAttributes({
          offeringId: this.state.selectedOfferId,
          offeringInstanceId: selectedOfferingInstanceId,
          completedDecisions: this.getCompletedDecisions(),
          completedAttributes: this.state.formattedAttributes,
          completedPhysicalAttributes: this.state.formattedPhysicalAttributes,
          isConvergentBiller: this.state.isDbss
        }).then(function () {
          // You can reset the Inventory Store Change flag, because the Shopping Cart Items now has the updated StoreId.
          _this27.actions.setInventoryStoreChangedFlag(false);
          if (_this27.state.isCheckoutStep) {
            return _this27.actions.calculateOfferingOrderQuote(_this27.state.customerInfo, _this27.state.shoppingCart, _this27.state.billCycle, undefined, undefined, undefined, _this27.overrideBypassQuoteConfiguration);
          }
          return null;
        }).catch(function (error) {
          _this27.uiNotificationService.transientError(error.translatedMessage);
          return Promise.reject();
        });
      }
    }
  }, {
    key: "closeSelectStorePopupDialog",
    value: function closeSelectStorePopupDialog(isApplyChanges, selectedStore) {
      this.showSelectStorePopup = false;
      if (isApplyChanges) {
        this.actions.setSelectedInventoryStores([selectedStore]);
      }
      this.actions.setInventoryRegionFilter(null);
      this.selectStorePopupApi.close();
    }
  }, {
    key: "onInventoryRegionFilterChanged",
    value: function onInventoryRegionFilterChanged(region) {
      this.actions.setInventoryRegionFilter(region);
    }
  }, {
    key: "onInventoryRegionFilterChangedForStoreSearch",
    value: function onInventoryRegionFilterChangedForStoreSearch(region) {
      this.actions.setInventoryRegionFilter(region);
      this.actions.resetAvailableInventoryInformation();
      var formattedInventories = this.state.physicalInventories,
        formattedPayload = !this.state.formattedInventories ? {
          InventoryTypes: formattedInventories,
          RegionId: region
        } : this.state.formattedPhysicalInventories;
      this.actions.searchInventoriesAvailability(formattedPayload).catch(this.onSearchInventoryAvailabilityFailure);
    }
  }, {
    key: "closeSearchInventoryPopupDialog",
    value: function closeSearchInventoryPopupDialog() {
      this.showStoreInventoryPopup = false;
      this.actions.setInventoryRegionFilter(null);
      this.storeSearchInventoryApi.close();
      if (this.isInventoryItemReservationFault) {
        this.openSendToStorePopup();
        this.isInventoryItemReservationFault = false;
      }
    }
  }, {
    key: "setSelectedStoreForSearchModal",
    value: function setSelectedStoreForSearchModal(selectedStore) {
      this.actions.setSelectedInventoryStores([selectedStore]);
      this.showStoreInventoryPopup = false;
      this.closeSearchInventoryPopupDialog();
      if (this.state.isAttributesStep) {
        this.fetchAttributesAndNavigate();
      } else {
        this._updateShoppingCartOnInventoryStoreChange();
      }
    }
  }, {
    key: "openStoreSearch",
    value: function openStoreSearch() {
      var _this28 = this;
      var isSearchInventoriesAvailability = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.showStoreInventoryPopup = true;
      this.$timeout(function () {
        _this28.storeSearchInventoryApi.open();
        if (isSearchInventoriesAvailability) {
          _this28.actions.searchInventoriesAvailability(_this28.state.formattedPhysicalInventories).catch(_this28.onSearchInventoryAvailabilityFailure);
        }
      });
    }
  }, {
    key: "getAddressKey",
    value: function getAddressKey() {
      if (this.state.isServiceabilityStep) {
        return pathOr(undefined, ['wizardForm', 'serviceabilityController.serviceabilityForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
      } else if (this.state.isCheckoutStep) {
        return pathOr(undefined, ['wizardForm', '$ctrl.paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
      } else if (this.state.isCustomerStep) {
        return pathOr(undefined, ['wizardForm', 'customerController.customerForm', 'createCustomerForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
      }
    }
  }, {
    key: "getAddressKeyForAddressValidatedThroughAPI",
    value: function getAddressKeyForAddressValidatedThroughAPI() {
      if (this.state.isServiceabilityStep) {
        return pathOr(undefined, ['wizardForm', 'serviceabilityController.serviceabilityForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
      } else if (this.state.isCheckoutStep) {
        return pathOr(undefined, ['wizardForm', '$ctrl.paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
      } else if (this.state.isCustomerStep) {
        return pathOr(undefined, ['wizardForm', 'customerController.customerForm', 'createCustomerForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
      }
    }
  }, {
    key: "getJobToken",
    value: function getJobToken() {
      var addressKey = this.getAddressKey(),
        addressKeyForAddressValidatedThroughAPI = this.getAddressKeyForAddressValidatedThroughAPI(),
        validatedAddressForCurrentAddress = this.state.validatedAddresses[addressKey],
        validatedAddressForAddressValidatedThroughAPI = this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
      if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
        return validatedAddressForCurrentAddress.JobToken;
      } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
        return validatedAddressForAddressValidatedThroughAPI.JobToken;
      }
      return null;
    }
  }, {
    key: "validateAddressWithAPI",
    value: function validateAddressWithAPI() {
      var addressKey = this.getAddressKey(),
        unvalidatedAddress = this.state.unvalidatedAddresses[addressKey],
        validatedAddress = this.state.validatedAddresses[addressKey];
      var addressTypes;
      if (this.state.isCheckoutStep) {
        //Refer to ./configure.autopay.constantsln 21 to see what the addressType should be
        addressTypes = {
          DefaultBilling: true
        };
      } else {
        //Refer to new.connect.wizard.actions ln 290 or buildAddressRequestObject fn in ./customer.helper.js
        addressTypes = {
          DefaultBilling: true,
          DefaultHome: true,
          DefaultPostal: true,
          DefaultService: true
        };
      }
      if (validatedAddress || !unvalidatedAddress) {
        return Promise.resolve(100);
      } else {
        return this.actions.validateAddress(addressKey, unvalidatedAddress, this.getJobToken(), addressTypes);
      }
    }
  }, {
    key: "updateCustomerInfoEditWithValidatedAddress",
    value: function updateCustomerInfoEditWithValidatedAddress() {
      var validatedAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (validatedAddress.Status) {
        this.actions.updateCustomerInfoEditCopy(Object.assign({}, this.state.customerInfoEdit, formatValidatedAddress(validatedAddress), {
          HomeCountry: validatedAddress.Country
        }));
      }
    }
  }, {
    key: "shouldValidateAddressWithAPIForServiceability",
    value: function shouldValidateAddressWithAPIForServiceability() {
      var customerInfo = this.state.customerInfoEdit;
      return !!customerInfo.addressLine1 && !!customerInfo.city && !!customerInfo.country && !!customerInfo.postalCode && !!customerInfo.stateRegionProvince;
    }
  }, {
    key: "changeOfferClick",
    value: function changeOfferClick() {
      var _this29 = this;
      this.isLoading = true;
      var saveOrderAction = this.state.createdCustomer ? this.actions.updateCustomerAndSaveOrder : this.actions.createCustomerAndSaveOrder;
      saveOrderAction(this.state.createdCustomer ? this.state.createdCustomer : this.state.customerInfoEdit, this.state.createdCustomer ? this.state.customerInfo : this.state.shoppingCart, this.state.createdCustomer ? this.state.shoppingCart : undefined).then(function (response) {
        var offer = pathOr(null, ['ShoppingCart', 'Items', '0'], response);
        _this29.actions.setChangeOfferingInstanceId(offer.OfferingInstanceId);
        _this29.actions.setChangeOfferingId(offer.OfferingId);
        _this29.deregisterUnsavedChanges();
        _this29.$state.go(ADD_OFFER_ORDER_URL, {
          'customerId': _this29.state.createdCustomer.Subscriber.Id
        });
      }).catch(function (error) {
        _this29.uiNotificationService.transientError(error.translatedMessage);
        // Intentionally not setting isLoading to false on .finally() due to it loading other api calls through the
        // process of transitioning to the add flow wizard
        _this29.isLoading = false;
      });
    }
  }, {
    key: "editOfferClick",
    value: function editOfferClick() {
      this.actions.setPaymentInfo(this.state.paymentInfoEdit);
      this.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.DECISIONS);
      this.closeViewFullCartPopupDialog();
    }
  }, {
    key: "onMoreActionSelected",
    value: function onMoreActionSelected(action) {
      switch (action) {
        case MINI_CART_MORE_ACTIONS.EDIT_SINGLE_OFFER:
          this.editOfferClick();
          break;
        case MINI_CART_MORE_ACTIONS.CHANGE:
          this.changeOfferClick();
          break;
        default:
          break;
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }

    //Below function is a promise
  }, {
    key: "proceedToFetchOffers",
    value: function proceedToFetchOffers() {
      var _this30 = this;
      this.isLoading = true;
      this.actions.updateCustomerInfo(this.state.customerInfoEdit);
      return this.actions.navigateToFetchOffers().then(function () {
        _this30.wizardForm.$setPristine();
        return Promise.resolve();
      });
    }
  }, {
    key: "onOverrideCalculateQuote",
    value: function onOverrideCalculateQuote() {
      this.overrideBypassQuoteConfiguration = true;
      this.fetchQuote(this.state.customerInfo);
    }
  }]);
}(OfferWizard);
export default {
  template: require('./new.connect.wizard.html'),
  controller: NewConnectWizardController,
  controllerAs: 'newConnectController'
};